import { render } from "./author-detail.vue?vue&type=template&id=480f61c8&scoped=true"
import script from "./author-detail.js?vue&type=script&lang=js&external"
export * from "./author-detail.js?vue&type=script&lang=js&external"

import "./author-detail.css?vue&type=style&index=0&id=480f61c8&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480f61c8"]])

export default __exports__